import { v1 } from '@/api/client';

const basePath = 'ecom/recommendation';

export const fetchRecommendations = () => v1.get<Recommendation[]>(basePath);

export const fetchRecommendationById = (recommendationId: string) =>
  v1.get<Recommendation>(`${basePath}/${recommendationId}`);

export const createRecommendation = (recommendation: Partial<Recommendation>) =>
  v1.post<Recommendation>(basePath, recommendation);

export const updateRecommendation = (recommendation: Partial<Recommendation>) =>
  v1.put<Recommendation>(`${basePath}/${recommendation.id}`, recommendation);

export const updateRecommendationStatus = ({
  recommendationId,
  status,
}: {
  recommendationId: string;
  status: RecommendationState;
}) =>
  v1.put<Recommendation>(`${basePath}/${recommendationId}/status/${status}`);

export const updateRecommendationItemsStatus = ({
  recommendationId,
  status,
  positions,
}: {
  recommendationId: string;
  status: RecommendationItemStatus;
  positions: number[];
}) =>
  Promise.all(
    positions.map((position) =>
      v1.put(
        `${basePath}/${recommendationId}/item/${position}/status/${status}`,
        undefined,
        { responseType: 'void' }
      )
    )
  );

export const deleteRecommendation = (recommendationId: string) =>
  v1.remove(`${basePath}/${recommendationId}`);
